import React from "react";
import {FOOTER_LEGAL, FOOTER_LINKS} from "./menu";

// The aspose.ai footer, rendered by this app instead of being injected at runtime by
// https://menucdn.containerize.com/core/engine.min.js. Same markup and class names as the
// "asposeai-en" venture served, so ./footer.css (lifted from the same source) still applies.

const Footer = () => (
    <div id="dvMenuFooter">
        <div className="footerbottom">

            <div className="footercol">
                <div className="bottomenuitems">
                    <ul>
                        {FOOTER_LINKS.map((link, i) => (
                            <React.Fragment key={link.href}>
                                {i > 0 && <li className="sep1">|</li>}
                                <li><a rel="nofollow" href={link.href}>{link.label}</a></li>
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="footer2bar">
                <div className="footer2col">
                    <div className="footer2text">
                        <p>© Aspose Pty Ltd 2001-{new Date().getFullYear()}. All Rights Reserved.</p>
                    </div>
                    <div className="footer2anchor">
                        <span className="footer2bottom">
                            {FOOTER_LEGAL.map((link, i) => (
                                <React.Fragment key={link.href}>
                                    {i > 0 && <> <span className="sep1">|</span> </>}
                                    <a rel="nofollow" href={link.href}>{link.label}</a>
                                </React.Fragment>
                            ))}
                        </span>
                    </div>
                </div>
            </div>

        </div>
    </div>
);

export default Footer;
